import { Box, MenuItem, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TextSearch from '../../controls/TextSearch';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { UserRole } from '../../../data/models/user-role.model';

const PREFIX = 'ClientUsersToolbarLeft';
const classes = {
  container: `${PREFIX}-container`,
  search: `${PREFIX}-search`,
  role: `${PREFIX}-role`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    gap: theme.spacing(2),
    width: '50%',
    minWidth: 400,
    alignItems: 'center',
  },
  [`& .${classes.search}`]: {
    flexGrow: 1,
  },
  [`& .${classes.role}`]: {
    width: 200,
  },
}));

interface ClientUsersToolbarProps {
  searchText: string;
  roleFilter: string;
  userRoles: UserRole[];
  onSearchTextChange: (val: string) => void;
  onRoleChange: (val: string) => void;
}

export default function ClientUsersToolbar({
  searchText,
  roleFilter,
  userRoles,
  onSearchTextChange,
  onRoleChange,
}: ClientUsersToolbarProps) {
  const { t } = useTranslation('common');

  return (
    <StyledBox className={classes.container}>
      <TextSearch
        className={classes.search}
        id="user-search"
        icon={<SearchIcon />}
        label={t('client.name')}
        placeholder={t('client.name')}
        onSearchChange={onSearchTextChange}
        currentSearchFilter={searchText}
      />
      <TextField
        select
        value={roleFilter}
        onChange={(e) => onRoleChange(e.target.value)}
        label={t('client.role')}
        className={classes.role}>
        <MenuItem value="0">{t('member.all')}</MenuItem>
        {userRoles.map((role) => (
          <MenuItem key={role.userRoleID} value={role.userRoleID}>
            {role.userRoleName}
          </MenuItem>
        ))}
      </TextField>
    </StyledBox>
  );
}
